 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		214: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"224bc6e","1":"fedd82a","2":"aeaccc4","3":"94571c5","4":"adfddbc","5":"e0347bf","6":"e6a9671","7":"02c5577","8":"ee2d5b5","9":"36de7ff","10":"02caa7a","11":"866ec10","12":"ba2dfac","13":"bd02cbe","14":"fb0f408","15":"76e1354","16":"f6704bd","17":"8ef5c39","18":"1ed8f4c","19":"a687e6b","20":"0cfc505","21":"36b7f1c","22":"448f4a0","23":"a6eb647","24":"1485b10","25":"918a3b6","26":"793abe6","27":"803cbe8","28":"08d1ecd","29":"5835643","30":"9c0eb01","31":"fec5835","32":"b47a794","33":"6f9e71a","34":"8548ec9","35":"b943b0f","36":"534c350","37":"e952c32","38":"78592c9","39":"7927496","40":"381a73f","41":"1ff07f0","42":"a3a8b62","43":"3e219b4","44":"119fff1","45":"003ff0f","46":"51f4db4","47":"0ff5955","48":"4032f23","49":"c6f1aed","50":"16f38d7","51":"2d53e06","52":"9b9064c","53":"9e94e01","54":"8b2b29d","55":"683ef41","56":"65cc95b","57":"3fc7b12","58":"e249822","59":"290c172","60":"00b6863","61":"64c0dfe","62":"c7828c8","63":"93d3087","64":"bdfb638","65":"1607883","66":"d87e9c4","67":"80c2855","68":"c9775ad","69":"4f44c2b","70":"d76d9be","71":"c58b053","72":"e5f34a4","73":"21be42b","74":"cb55cd8","75":"037d3ab","76":"72beee3","77":"b0ee3f8","78":"c3e944b","79":"2f886d0","80":"23ae4c2","81":"60e4f9d","82":"6e91c47","83":"050f9f3","84":"bd0e3e6","85":"08dd1b4","86":"052620a","87":"5ada056","88":"4d55867","89":"da667dc","90":"f30317a","91":"65ab57b","92":"bc5acfd","93":"1aec8b8","94":"a7372e9","95":"cf5c222","96":"8adb437","97":"e289692","98":"6286d4a","99":"c591d2c","100":"7de2c9e","101":"037e665","102":"74fcf0a","103":"3f39129","104":"6c8bebd","105":"e1fc9e2","106":"9a0b3a6","107":"2a7b902","110":"979f5dd","111":"dea9f96","112":"4e9b292","113":"772c883","114":"f0a934b","115":"2f504b2","116":"e21e660","117":"1cab686","118":"c6f75a7","119":"91ced69","120":"c3e3391","121":"da345f2","122":"e1ed3e1","123":"b738bb6","124":"60a7456","125":"6706769","126":"a412084","127":"1f56389","128":"d94afe0","129":"f5d5ec6","130":"b5dfaed","131":"041a853","132":"ddab265","133":"662ffa0","134":"69b28d4","135":"32fd497","136":"e108af7","137":"b164dd3","138":"d81736a","139":"27ce2b4","140":"fbe9d75","141":"26ad81e","142":"7647795","143":"2a05d73","144":"00106ba","145":"3da11de","146":"a2afda7","147":"ba8e1f4","148":"aadcef6","149":"dca392e","150":"2943cdd","151":"0a1cb7d","152":"f7f658b","153":"536edef","154":"955750d","155":"69b8fd8","156":"ae2f25d","157":"34b5263","158":"8abbc4b","159":"f62c6a2","160":"21122a0","161":"0875f9d","162":"aeaa986","163":"cc9694e","164":"7b8b29c","165":"e04b874","166":"46b2ed9","167":"62b055f","168":"2095f38","169":"c53e02a","170":"27862ef","171":"2f1a2ca","172":"04fa2b1","173":"fc2ab41","174":"bdd81bc","175":"78ced8b","176":"e2dd1bf","177":"4cbbf8f","178":"fd90410","179":"47dbcaf","180":"cb667d8","181":"6aaa636","182":"f6f0b13","183":"6feb2f5","184":"931b194","185":"56fd37d","186":"434128d","187":"5452d8e","188":"c76e8d8","189":"df178c8","190":"46fa25d","191":"3d11842","192":"6819450","193":"085d676","194":"1117f95","195":"de5612f","196":"70e5784","197":"b3a2570","198":"450e6ef","199":"15616b0","200":"d117ffd","201":"2552e69","202":"f7518fe","203":"6b495bc","204":"3e078c9","205":"17f6849","206":"331947d","207":"de55c78","208":"740d328","209":"cc2b154","210":"d97ab5f","211":"c99888b","212":"ef77fef","213":"1e42b81","216":"0ee0165","217":"97a2475","218":"f227de0","219":"8e4b124","220":"ed5b0f0","221":"3ff2963","222":"dfa9404","223":"a1a713b","224":"e802a3c","225":"fc62003","226":"f42ce2e","227":"3a1d593","228":"186d10a","229":"b9b1ada","230":"8ec8da3","231":"9f76532","232":"8e1e326","233":"963db9d","234":"0df3c8b","235":"c0dd207","236":"c0698cc","237":"709cfb3","238":"c91efc3","239":"284a513","240":"85df240","241":"5c5d192","242":"ade6e12","243":"7ace8db","244":"7ed850b","245":"c82def7","246":"f7e7e49","247":"a7d69b4","248":"78f5147","249":"c3d7a4d","250":"bee15dd","251":"0ef8220","252":"ee94eab","253":"d6f9916","254":"3ecd451","255":"0b69923","256":"6d4b460","257":"c8626bd","258":"c15d302","259":"0a7e0b0","260":"510ba24","261":"2f519dd","262":"cda0eb1","263":"654a789","264":"d14fccc","265":"ced7b76","266":"a9622d2","267":"acf58a6","268":"cfee4d5","269":"1a735c3","270":"56b3de5","271":"6dfad1f","272":"e542ce1","273":"23b1b59","274":"c188d63","275":"01e95d9","276":"66eaead","277":"cdccefd","278":"3a93413","279":"4ec3db7","280":"31b50e7","281":"066b6fa","282":"1553357","283":"78cd0b9","284":"bbade9c","285":"7984b3a","286":"b921ef2","287":"8095531","288":"83aac16","289":"07b2b60","290":"b235146","291":"1b1b48a","292":"89a46f0","293":"677a796","294":"b28a479","295":"90c40f9","296":"1afdc7b","297":"844285e","298":"abeea04","299":"197ca73","300":"21ab2fb","301":"9583eab","302":"8277e12","303":"67df4b1","304":"9e3cc7e","305":"b1905e5","306":"880d01b","307":"47cd0f5","308":"50888b2","309":"37922e5","310":"55ee820","311":"1ae66b6","312":"0c09f43","313":"ca14285","314":"4eabc94","315":"f1f44b8","316":"943a9fc","317":"c5dd45d","318":"a49cdae","319":"898113e","320":"7cf2c3d","321":"b0249c2","322":"4ec8499","323":"77c5d93","324":"9b109a6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d1mf56q6wc1y19.cloudfront.net/channels2022/220519/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
